import SeoHelmet from '@/components/UI/SeoHelmet';
import React from 'react';
import seoImg from "@/public/img/seo/impressum.png";

const TermsPage: React.FC = () => {

    return (
        <>
            <SeoHelmet
                title="Impressum – Yobsti"
                description="Impressum der Yobsti GmbH – alle rechtlichen Angaben gemäß §5 TMG."
                image={seoImg}
                url="https://www.yobsti.de/impressum"
            />

            <article className="prose prose-lg max-w-4xl px-4 mx-auto">
                <h1 className="text-3xl font-bold text-primary mb-4 mt-8">Impressum</h1>
                <h2 className="text-2xl font-bold text-primary mb-4">Angaben gemäß § 5 TMG</h2>
                <p className="leading-relaxed">Yobsti Nahversorgung GmbH</p>
                <p className="leading-relaxed">Hafenstraße 25</p>
                <p className="mb-2 leading-relaxed">68159 Mannheim</p>
                <p className="leading-relaxed">Amtsgericht Mannheim</p>
                <p className="mb-2 leading-relaxed">HRB 741524</p>
                <p className="leading-relaxed">Geschäftsführung: Andre Tiede</p>
                <br></br>
                <p className="leading-relaxed">Kontakt:</p>
                <p className="leading-relaxed">Email: info@yobsti.de</p>
                <p className="leading-relaxed">USt.-ID: DE346401082</p>
                <br></br>
                <p className="leading-relaxed font-bold">Streitschlichtung</p>
                <p className="mb-4 leading-relaxed">Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr.</p>
                <p className="mb-4 leading-relaxed">Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
                <p className="leading-relaxed font-bold">Verbraucherstreitbeilegung & Universalschlichtungsstelle</p>
                <p className="mb-4 leading-relaxed">Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
            </article>
        </>
    );
};

export default TermsPage;
